import { loanImportsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const getLoanImportsAction = catchAsyncActionError(
  ({ providerKey, ...params }) =>
    async () => {
      const { data } = await loanImportsApi.getImports(providerKey, params);

      return data;
    },
);

export const getLoanImportAction = catchAsyncActionError(({ providerKey, id }) => async () => {
  const { data } = await loanImportsApi.getImport(providerKey, id);

  return data;
});

export const retryLoanImportExportAction = catchAsyncActionError(
  ({ providerKey, id }) =>
    async () => {
      const { data } = await loanImportsApi.retryExport(providerKey, id);

      return data;
    },
);

export const retryLoanImportAction = catchAsyncActionError(({ providerKey, id }) => async () => {
  const { data } = await loanImportsApi.retryImport(providerKey, id);

  return data;
});

export const releaseLoanImportAction = catchAsyncActionError(({ providerKey, id }) => async () => {
  const { data } = await loanImportsApi.releaseImport(providerKey, id);

  return data;
});
